export const GET_TOPICS_REQUEST = 'GET_TOPICS_REQUEST';
export const GET_TOPICS_SUCCESS = 'GET_TOPICS_SUCCESS';
export const GET_TOPICS_FAILED = 'GET_TOPICS_FAILED';

export const FETCH_SINGLE_TOPIC_REQUEST = 'FETCH_SINGLE_TOPIC_REQUEST';
export const FETCH_SINGLE_TOPIC_SUCCESS = 'FETCH_SINGLE_TOPIC_SUCCESS';
export const FETCH_SINGLE_TOPIC_FAILED = 'FETCH_SINGLE_TOPIC_FAILED';

export const ADD_TOPIC_REQUEST = 'ADD_TOPIC_REQUEST';
export const ADD_TOPIC_SUCCESS = 'ADD_TOPIC_SUCCESS';
export const ADD_TOPIC_FAILED = 'ADD_TOPIC_FAILED';

export const DELETE_TOPIC_REQUEST = 'DELETE_TOPIC_REQUEST';
export const DELETE_TOPIC_SUCCESS = 'DELETE_TOPIC_SUCCESS';
export const DELETE_TOPIC_FAILED = 'DELETE_TOPIC_FAILED';

export const EDIT_TOPIC_REQUEST = 'EDIT_TOPIC_REQUEST';
export const EDIT_TOPIC_SUCCESS = 'EDIT_TOPIC_SUCCESS';
export const EDIT_TOPIC_FAILED = 'EDIT_TOPIC_FAILED';

export const GET_TOPIC_QUESTIONS_REQUEST = 'GET_TOPIC_QUESTIONS_REQUEST';
export const GET_TOPIC_QUESTIONS_SUCCESS = 'GET_TOPIC_QUESTIONS_SUCCESS';
export const GET_TOPIC_QUESTIONS_FAILED = 'GET_TOPIC_QUESTIONS_FAILED';

export const ADD_QUESTION_TOPIC_REQUEST = 'ADD_QUESTION_TOPIC_REQUEST';
export const ADD_QUESTION_TOPIC_SUCCESS = 'ADD_QUESTION_TOPIC_SUCCESS';
export const ADD_QUESTION_TOPIC_FAILED = 'ADD_QUESTION_TOPIC_FAILED';

export const DELETE_QUESTION_REQUEST = 'DELETE_QUESTION_REQUEST';
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS';
export const DELETE_QUESTION_FAILED = 'DELETE_QUESTION_FAILED';

export const EDIT_QUESTION_REQUEST = 'EDIT_QUESTION_REQUEST';
export const EDIT_QUESTION_SUCCESS = 'EDIT_QUESTION_SUCCESS';
export const EDIT_QUESTION_FAILED = 'EDIT_QUESTION_FAILED';

export const GET_ALL_QUESTIONS_REQUEST = 'GET_ALL_QUESTIONS_REQUEST';
export const GET_ALL_QUESTIONS_SUCCESS = 'GET_ALL_QUESTIONS_SUCCESS';
export const GET_ALL_QUESTIONS_FAILED = 'GET_ALL_QUESTIONS_FAILED';

export const RESET_TOPICS = 'RESET_TOPICS';
